// error-boundary.ts
import { html } from "lit";
function errorBoundary(render) {
  return (...args) => {
    try {
      return render(...args);
    } catch (err) {
      console.error(err);
      return html`
        <div class="flex flex-col justify-center items-center h-full p-4 bg-error text-error-content">
          <h2 class="text-2xl font-bold mb-2">An error occurred</h2>
          <p>${err}</p>
        </div>
      `;
    }
  };
}
export {
  errorBoundary
};
